.filterDrawer {
  padding: 0 0 16px !important;
  height: 100vh;
  /* biome-ignore lint/suspicious/noDuplicateProperties: 100vh used as fallback for browsers that don't support svh */
  height: 100svh;
  display: grid;
  grid-template-rows: auto 1fr auto;

  header {
    margin: 0 !important;
  }

  .content {
    overflow-y: auto;
    padding: 0 16px 16px;
  }

  footer {
    background: transparent;
    border-top: 1px solid var(--color-parchment-dark);
    display: flex;
    gap: 8px;
    padding-top: 16px;
  }
}
